export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10225.f27de41e.jpg";